import React, { FC } from 'react';
import footerLogos from 'assets/images/footerLogos.png';
import { useCountryContext } from 'context/CountryProvider';
import { ECountry } from 'common/const';
import { getAppSettings } from 'common/settings';

/* Реквизиты не переводятся (US-019), зависят от действующей страны (US-034, R-11);
 *  ссылка звонка = видимый номер (R-15). */
const FOOTER_PHONES: Record<ECountry, { label: string; href: string }> = {
  [ECountry.RS]: { label: '+381 65 5603 250', href: 'tel:+381655603250' },
  [ECountry.ME]: { label: '+382 69 820 696', href: 'tel:+38269820696' },
};

interface IComponentProps {
  background?: string;
}

export const Footer: FC<IComponentProps> = ({ background = '#ffffff' }) => {
  const { country } = useCountryContext();
  const phone = FOOTER_PHONES[country];

  return (
    <div className="footer" style={{ background }}>
      <img src={footerLogos} alt="footer logos" />
      {country === ECountry.ME ? (
        <p>BO Solution d.o.o. Podgorica</p>
      ) : (
        <p>
          <a className="link" href={getAppSettings().landingUrl}>
            Hvala.tips
          </a>
          &nbsp; doo Beograd
        </p>
      )}
      <a href="mailto:hello@hvala.tips">hello@hvala.tips</a>
      <a href={phone.href}>{phone.label}</a>
    </div>
  );
};
